const SalesReturn_sample= [
  {
    orderData: {
      srt_id: "srt_id",
      store_id: "store_id",
      cmr_phone_number: "cmr_phone_number",
      srt_total_gst: "srt_total_gst",
      srt_total_discount: "srt_total_discount",
      srt_payment_status: "srt_payment_status",
      srt_transaction_id: "srt_transaction_id",
      srt_order_status: "srt_order_status",
      srt_payment_method: "srt_payment_method",
      srt_billing_address: "srt_billing_address",
      srt_total_amount: "srt_total_amount",
      srt_sub_total: "srt_sub_total",
      srt_round_off_value: "srt_round_off_value",
      srt_delivery_date: "srt_delivery_date",
      srt_document_date: "srt_document_date",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      cmr_id: "cmr_id",
      remarks: "remarks",
      created_date: "created_date",
      update_date: "update_date",
      tds_tcs_type: "tds_tcs_type",
      tcs_or_tds_percentage: "tcs_or_tds_percentage",
      tcs_or_tds_amount: "tcs_or_tds_amount",
      tcs_or_tds_percentage_id: "tcs_or_tds_percentage_id",
      srt_invoice_discount: "srt_invoice_discount",
      srt_invoice_discount_percentage: "srt_invoice_discount_percentage",
      srt_is_invoice_dis_percentage: "srt_is_invoice_dis_percentage",
      srt_ship_to_address: {
        cmr_id: "cmr_id",
        update_date: "update_date",
        created_date: "created_date",
        cmr_default_address: "cmr_default_address",
        cmr_ship_address_id: "cmr_ship_address_id",
        cmr_ship_address_city: "cmr_ship_address_city",
        cmr_ship_address_name: "cmr_ship_address_name",
        cmr_ship_address_town: "cmr_ship_address_town",
        cmr_ship_address_state: "cmr_ship_address_state",
        cmr_ship_address_street: "cmr_ship_address_street",
        cmr_ship_address_address: "cmr_ship_address_address",
        cmr_ship_address_country: "cmr_ship_address_country",
        cmr_ship_address_pincode: "cmr_ship_address_pincode",
        cmr_ship_address_district: "cmr_ship_address_district"
      },
      srt_pay_to_address: {
        cmr_id: "cmr_id",
        update_date: "update_date",
        created_date: "created_date",
        cmr_pay_address_id: "cmr_pay_address_id",
        cmr_default_address: "cmr_default_address",
        cmr_pay_address_city: "cmr_pay_address_city",
        cmr_pay_address_name: "cmr_pay_address_name",
        cmr_pay_address_town: "cmr_pay_address_town",
        cmr_pay_address_state: "cmr_pay_address_state",
        cmr_pay_address_street: "cmr_pay_address_street",
        cmr_pay_address_address: "cmr_pay_address_address",
        cmr_pay_address_country: "cmr_pay_address_country",
        cmr_pay_address_pincode: "cmr_pay_address_pincode",
        cmr_pay_address_district: "cmr_pay_address_district"
      }
    },
    itemData: [
      {
        item_id: "item_id",
        item_code: "item_code",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        item_pack_size: "item_pack_size",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_batch_number: "item_batch_number",
        sodtt_id: "sodtt_id",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_batch_quantity: "item_batch_quantity",
        item_exp_date: "item_exp_date",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_uom: "item_uom",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        item_free_quantity: "item_free_quantity",
        item_credit_quanity_remaining: "item_credit_quanity_remaining",
        item_uom_id: "item_uom_id",
        itemBatchData: [
          {
            item_batch_number: "item_batch_number",
            item_id: "item_id",
            item_batch_quantity: "item_batch_quantity",
            item_exp_date: "item_exp_date",
            item_batch_unit_price: "item_batch_unit_price",
            from_bin_location: "from_bin_location",
            from_bin_id: "from_bin_id",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_total_sales_rate: "item_batch_total_sales_rate",
            item_batch_final_sales_rate: "item_batch_final_sales_rate",
            item_batch_sales_rate: "item_batch_sales_rate",
            item_batch_total_base_sales_rate: "item_batch_total_base_sales_rate",
            item_batch_discounted_sales_rate: "item_batch_discounted_sales_rate"
          }
        ],
        total_sellable_quantity: "total_sellable_quantity"
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {SalesReturn_sample,storeDetailsResult_sample};